






































import Vue from "vue"
import IconOnCircleBackground from "~/components/guideline/icon/IconOnCircleBackground.vue"

export default Vue.extend({
  components: {
    IconOnCircleBackground,
  },
  props: {
    hasMenu: {
      type: Boolean,
      default: false,
    },
    mainAccountImageUrl: {
      type: String,
      default: null,
    },
  },
  methods: {
    navigateToChatList() {
      this.$nuxt.$router.push({ path: "/corporation/chats" })
    },
  },
})
